import useViewContext from '/druid/internal/useViewContext';

export default function useIndex() {
  const { index } = useViewContext();

  return [index];
}
